import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/langman-aiqing' },
  { name: '排行榜', path: '/ranking' },
  { name: '作者', path: '/authors' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-white/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between h-16 px-6 md:px-10 max-w-[1440px] mx-auto">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-leaf-fill text-2xl" style={{ color: isScrolled ? '#5c7a3c' : '#ffffff' }}></i>
            </div>
            <span
              className={`text-xl font-bold font-[family-name:var(--font-heading)] tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-stone-800' : 'text-white'
              }`}
            >
              韩漫屋
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? (isScrolled ? 'text-stone-900' : 'text-white')
                    : (isScrolled ? 'text-stone-500 hover:text-stone-800' : 'text-white/80 hover:text-white')
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-stone-600 hover:text-stone-900' : 'text-white/80 hover:text-white'
            }`}>
              登录
            </button>
            <Link
              to="/about"
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer ${
                isScrolled ? 'bg-stone-100 hover:bg-stone-200' : 'bg-white/20 hover:bg-white/30'
              }`}
              aria-label="关于我们"
            >
              <i className={`ri-arrow-right-line text-lg ${isScrolled ? 'text-stone-600' : 'text-white'}`}></i>
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg transition-colors ${
              isScrolled ? 'text-stone-700 hover:bg-stone-100' : 'text-white hover:bg-white/20'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bg-white shadow-lg rounded-b-2xl p-6">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'bg-stone-100 text-stone-900'
                      : 'text-stone-600 hover:bg-stone-50 hover:text-stone-900'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="border-t border-stone-100 mt-2 pt-2">
                <button className="w-full px-4 py-3 rounded-lg text-sm font-medium text-stone-600 hover:bg-stone-50 hover:text-stone-900 text-left whitespace-nowrap cursor-pointer">
                  登录
                </button>
                <Link
                  to="/about"
                  className="block px-4 py-3 rounded-lg text-sm font-medium text-stone-600 hover:bg-stone-50 hover:text-stone-900 whitespace-nowrap"
                >
                  关于我们
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}